import { fetchAuthSession } from '@aws-amplify/auth';

const GetCapsuleImages = async (
  capsuleID: string,
  setCapsuleImages: (images: string[]) => void
): Promise<void> => {
  const apiUrl = `https://lfnawfdz0a.execute-api.ap-southeast-2.amazonaws.com/capsule/getimages/${capsuleID}`;

  try {
    const { tokens } = await fetchAuthSession();
    const authToken = tokens?.accessToken?.toString();

    if (!authToken) {
      throw new Error('No auth token available');
    }

    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'x-api-key': authToken,
        'Content-Type': 'application/json',
      }
    });

    if (response.ok) {
      const data = await response.json();
      setCapsuleImages(data.secureImages);
    } else {
      console.error('Failed to fetch image URLs');
      setCapsuleImages([]);
    }
  } catch (err) {
    console.error('Error fetching image URLs:', err);
    setCapsuleImages([]);
  }
};

export default GetCapsuleImages;